/* global axios */
import ApiClient from '../ApiClient';

class WhatsappQrChannel extends ApiClient {
  constructor() {
    super('whatsapp_qr', { accountScoped: true });
  }

  fetchQr(inboxId) {
    return axios.get(`${this.baseUrl()}/whatsapp_qr/qr`, {
      params: inboxId ? { inbox_id: inboxId } : undefined,
    });
  }

  fetchStatus(inboxId) {
    return axios.get(`${this.baseUrl()}/whatsapp_qr/status`, {
      params: inboxId ? { inbox_id: inboxId } : undefined,
    });
  }

  complete() {
    return axios.post(`${this.baseUrl()}/whatsapp_qr/complete`);
  }

  sync(inboxId) {
    return axios.post(`${this.baseUrl()}/whatsapp_qr/sync`, {
      inbox_id: inboxId,
    });
  }

  syncContacts(inboxId, { contacts = true, groups = false } = {}) {
    return axios.post(`${this.baseUrl()}/whatsapp_qr/sync_contacts`, {
      inbox_id: inboxId,
      contacts,
      groups,
    });
  }
}

export default new WhatsappQrChannel();
